export const EducationData = [
  {
    degree: "Bachelor of Science in Computer Science",
    institution: "Kotebe University of Education",
    year: "2018 - 2022",
    description: "Focused on web development, algorithms, and data structures.",
    certificate:
      "https://drive.google.com/file/d/1lBinQGVywbNaBjRh4hReSn2-xBztvcHO/view?usp=drive_link",
  },
  {
    degree: "Programming Fundamentals Bootcamp",
    institution: "Udacity",
    year: "2024",
    description:
      "8-week program covering modern web technologies including Javascript, DOM manipulation, HTML and CSS.",
    certificate:
      "https://www.udacity.com/certificate/e/31fd46ac-5fd3-11ef-abaf-8353d7344e2f",
  },
];
